import React, { useState, useContext } from "react";
import ConfigComponent from "../../ConfigComponent";
import { CurrencySelector } from "../../library/CurrencySelector";
import Button, { ButtonContainer } from "../../library/Buttons";
import Title from '../../library/Title';
import StartOver from '../../library/StartOver';
import { actions, StateContext } from "../../../state/index";
import { getConvertedCurrency } from "../../../api/index";
import { HTTP_REQUEST_TYPES, TOKEN_TYPES } from "../../../utils/enums";
import { logHttpError } from "../../../utils/logging";
import { HttpRequestException } from "../../../utils/errors";

export const SelectCurrencyFlow = ({ acceptPayment }) => {
  const [applicationState, dispatch] = useContext(StateContext);
  const {configuration, payment, tokens} = applicationState;
  const [convertedAmount, setConvertedAmount] = useState(payment.amount);
  const [selectedCurrency, setSelectedCurrency] = useState(payment.currency);

  const dataForVariableSubstitutions = {
    payment: { ...payment, amount: convertedAmount, currency: selectedCurrency },
    currency: selectedCurrency,
  };

  return (
    <>
      <Title>
        <h1>{configuration.acceptPayment.title}</h1>
      </Title>
      <section className="main">
        <div className="currency-selector-description-container">
          <span className="currency-selector-description">
            <ConfigComponent
              config={configuration.acceptPayment.description}
              data={dataForVariableSubstitutions}
            />
          </span>
        </div>
        <CurrencySelector
          defaultCurrency={payment.currency}
          currencyOptions={configuration.acceptPayment.currencyOptions}
          onChange={async currency => {
            const getConvertedCurrencyData = {
              fromCurrency: payment.currency,
              toCurrency: currency,
              amount: payment.amount,
            };

            try {
              const convertedAmount = await getConvertedCurrency(getConvertedCurrencyData, tokens[TOKEN_TYPES.VALIDATE_PAYMENT].access_token);
              setConvertedAmount(convertedAmount);
              setSelectedCurrency(currency);
            } catch (error) {
              const httpRequestException = HttpRequestException(HTTP_REQUEST_TYPES.CURRENCY_CONVERSIONS, error);
              logHttpError(httpRequestException, applicationState);
              dispatch(actions.modals.showHttpErrorModal(configuration, {
                errorType: httpRequestException.errorType,
                serverResponse: httpRequestException.serverResponse,
                propsByHttpStatus: {
                  default: {
                    actions: [{
                      label: 'Try Again',
                      onClick: () => {
                        setConvertedAmount(payment.amount);
                        setSelectedCurrency(payment.currency);
                      },
                    }]
                  },
                  401: {
                    actions: [{
                      label: 'Start Over',
                      onClick: () => dispatch(actions.startOver()),
                    }],
                    showFaqLink: false,
                  }
                }
              }));
            }
          }}
        />
        <ButtonContainer>
          <Button
            onClick={() =>
              acceptPayment({
                acceptedAmount: convertedAmount,
                acceptedCurrency: selectedCurrency
              })
            }
          >
            <ConfigComponent config={configuration.acceptPayment.btnLabel}/>
          </Button>
        </ButtonContainer>
        <StartOver/>
      </section>
    </>
  );
};

export default SelectCurrencyFlow;
